import { Axios } from "./axiosInstance.js";
import configSettings from './../config.js';

export const productPreviewUrlsService = (siteProduct) => {
   const baseUrl = configSettings.vendorPortalBaseUrl;


    return Axios.createInstanceWithApiKey()({
      method: 'get',
      url:`${baseUrl}VendorProducts/GetPreviewUrls?productId=${siteProduct.productId}&siteId=${siteProduct.siteId}`,
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        dataType: 'json'
      },
    });
}
